import { Component, OnInit } from '@angular/core';
import { HttpSecureFileService } from '../../service/http-secure-file.service';
import { Router } from '@angular/router';
import { OtpAuthService } from '../../service/otp-auth.service';
import { catchError } from 'rxjs';
import { SecureFileDto } from '../../service/dto';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-secure-file',
	templateUrl: './secure-file.component.html',
	styleUrls: ['./secure-file.component.scss'],
	standalone: false
})
export class SecureFileComponent implements OnInit {

	smsId!: number | null;
	otp!: string | null;

	secureFiles!: SecureFileDto[];

	constructor(
		private otpAuth: OtpAuthService, 
		private router: Router, 
		private httpService: HttpSecureFileService,
		private toastr: ToastrService) {}

	ngOnInit(): void {
		this.smsId = this.otpAuth.getSmsId();	
		this.otp = this.otpAuth.getOtp();	

		if (this.smsId === null || this.otp === null) {
			this.router.navigate(['/secfile', 'null']);
			return;
		}

		this.httpService.getFileList(this.smsId, this.otp)
		.pipe(
			catchError(error => {
				console.log('Error fetching file list', error);
				this.toastr.error('Failed to fetch files');
				throw error;
			})
		)
		.subscribe(data => {
			this.secureFiles = data;
		});
	}

	download(file: SecureFileDto) {
		if (this.smsId === null || this.otp === null) {
			this.router.navigate(['/secfile', 'null']);
			return;
		}
		this.httpService.downloadFile(this.smsId, this.otp, file.uuid).subscribe();
	}

	downloadAll() {
		if (this.smsId === null || this.otp === null) {
			this.router.navigate(['/secfile', 'null']);
			return;
		}
		this.httpService.downloadAll(this.smsId, this.otp).subscribe();
	}

	logout() {
		var smsId = this.otpAuth.getSmsId();
		this.otpAuth.clear();
		this.router.navigate(['/secfile', smsId]);
	}
}
